import React from "react";
import { IconInfoCircleFilled } from "@tabler/icons-react";
import { useSelector } from "react-redux";

const ModalNonEarlyBird = (props) => {
  const categoryUser = useSelector((state) => state.categoryUserSelected);
  //   console.log(np.nominalPayment);
  return (
    <>
      <div className="row mb-3">
        <div
          className="card mb-3"
          style={{
            backgroundColor: "#FFF5F8",
            marginBottom: "15px",
            borderColor: "#F1416C",
          }}
        >
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12 d-flex">
                <div className="col-lg-2 col-12">
                  <IconInfoCircleFilled
                    width="65px"
                    height="65px"
                    style={{ color: "#F1416C" }}
                  />
                </div>
                <div className="col-lg-10 col-12">
                  <div className="row">
                    <h4 style={{ color: "#F1416C" }}>
                      Cek Konfirmasi Data Pendaftaran!
                    </h4>
                  </div>
                  <div className="row">
                    <h5>
                      Setelah ini, mohon periksa kembali konfirmasi data
                      pendaftaran Anda sebelum melanjutkan.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card border-warning"
          style={{ backgroundColor: "#FFF3CD", marginBottom: "15px" }}
        >
          <div className="card-body">
            <div className="row">
              <h4 className="mb-3">Informasi Pembayaran : </h4>
              <div className="col-12 mb-3">
                <h4 className="mb-2">1. Pembayaran Sekarang</h4>
                <ul>
                  <li>
                    - Klik <b>"Bayar Sekarang"</b> untuk pembayaran dimuka.
                  </li>
                  <li>
                    - Pembayaran akan dialihkan{" "}
                    <b>melalui platform pembayaran kami</b>.
                  </li>
                  <li>
                    - Pembayaran{" "}
                    <b>
                      harus diselesaikan sebelum due date (H-1 program
                      dilaksanakan)
                    </b>
                    .
                  </li>
                  <li>
                    - Konfirmasi atau invoice pembayaran akan dikirimkan melalui
                    email dari platform pembayaran kami. Harap pastikan untuk
                    menyelesaikan pembayaran sesuai intruksi dalam email
                    tersebut.
                  </li>
                </ul>
              </div>
              {categoryUser.value === "corporate" ? (
                <>
                  <div className="col-12 mb-3">
                    <h4 className="mb-2">2. Pembayaran Setelah Program</h4>
                    <ul>
                      <li>
                        - Klik <b>"Bayar Nanti"</b> untuk{" "}
                        <b>pembayaran setelah program</b>.
                      </li>
                      <li>
                        - Jika memilih opsi ini. silahkan{" "}
                        <b>mengupload Guarantee Letter (GL)</b> maksimal H-1
                        program dilaksanakan.
                      </li>
                      <li>
                        - Untuk <b>bukti pembayaran</b> dapat diupload di bagian
                        Dashboard Transaksi <b>maksimal 14 hari</b> setelah
                        invoice diterima.
                      </li>
                    </ul>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-outline-success"
            onClick={props.showOpsiBtnBayar}
          >
            Oke, Lanjutkan
          </button>
        </div>
      </div>
    </>
  );
};

export default ModalNonEarlyBird;
